import RouterMiddleware from "src/middleware/RouterMiddleware";
import AuthMiddleware from "src/middleware/AuthMiddleware";
import AlertMiddleware from "src/middleware/AlertMiddleware";
import RoleMiddleware from "src/middleware/RoleMiddleware";

export default new RouterMiddleware({
  RequireAuth: AuthMiddleware,
  auth: AuthMiddleware,
  alert: AlertMiddleware,
  role: RoleMiddleware,
});
